import moment from "moment";

export default {
  type: "establishment-internal-orders",
  code: null,
  name: "",
  // Next monday by default: a weekly order is prepared for the week ahead.
  week_starts_at: moment().add(1, "week").startOf("isoWeek").format("YYYY-MM-DD"),
  week_ends_at: moment()
    .add(1, "week")
    .startOf("isoWeek")
    .add(4, "days")
    .format("YYYY-MM-DD"),
  status: "DRAFT",
  invoicing_status: "PENDING",
  excerpt: "",
  relationshipNames: [
    "organization",
    "serviceCenter",
    "sourceEstablishment",
    "destinationEstablishment",
    "sourceCafeteria",
    "destinationCafeteria",
    "items",
  ],
  organization: {
    type: "organizations",
    id: null,
  },
  sourceEstablishment: {
    type: "establishments",
    id: null,
  },
  destinationEstablishment: {
    type: "establishments",
    id: null,
  },
  sourceCafeteria: {
    type: "cafeterias",
    id: null,
  },
  destinationCafeteria: {
    type: "cafeterias",
    id: null,
  },
  items: [],
};
